import shared from './shared';

/**
 * File Overview
 * Normalization helper object for the body data API
 */
export default {
  normalize(data) {
    const normalizedData = {};
    normalizedData.bikeSize = this.unitlessSize(data.bike_size);
    normalizedData.bikeSizeMountain = this.isMountain(normalizedData.bikeSize);
    normalizedData.saddleHeight = data.saddle_height;

    normalizedData.productMatches = data.recommended_bikes.map((obj, i) => {
      let newObj = Object.assign({}, obj);

      newObj.id = i;
      newObj.image = newObj.mpl_image_url;
      newObj.type = 'bike';
      newObj.url = newObj.url || 'https://www.specialized.com';
      newObj.description = shared.stripDescription(newObj.description);
      newObj.size = this.unitlessSize(newObj.size);
      newObj.mountain = this.isMountain(newObj.size);
      return newObj;
    });

    return normalizedData;
  },

  unitlessSize(size) {
    return size.replace('cm', '');
  },

  isMountain(size) {
    return !(/\d/.test(size));
  }
}



// WEBPACK FOOTER //
// ./src/client/normalizers/bike-data-normalizer.js